import React from "react";
import { Form, Input, InputNumber, Tooltip } from "antd";
import "../../styles/Components/inputfields.css";

const InputField = ({
  disabled,
  rows,
  suffix,
  formclass,
  onChange,
  className,
  name,
  type,
  placeholder,
  rules,
  tooltipTitle,
  ...rest
}) => {
  const { TextArea } = Input;

  return (
    <Form.Item className={formclass} name={name} rules={rules} {...rest}>
      {type === "password" ? (
        <Input.Password
          className={className}
          placeholder={placeholder}
          onChange={onChange}
          disabled={disabled}
        />
      ) : type === "textarea" ? (
        <TextArea
          className={className}
          placeholder={placeholder}
          onChange={onChange}
          rows={rows || 4}
          disabled={disabled}
        />
      ) : type === "number" ? (
        <InputNumber
        controls={false}
          className={className}
          placeholder={placeholder}
          onChange={onChange}
          suffix={suffix}
          disabled={disabled}
          style={{ width: "100%" }} // Ensures it fits like an Input field
        />
      ) : (
        <Input
          className={className}
          placeholder={placeholder}
          onChange={onChange}
          suffix={suffix}
          disabled={disabled}
        />
      )}
    </Form.Item>
  );
};

export default InputField;
